export default __webpack_public_path__ + "static/media/serv1.9f5795d9.png";